module.exports = __webpack_public_path__ + "static/media/smp3watulimo.55823be8.jpg";